// fieldConfig.js
import {states} from "../../utils/states";


export const formFields = {
    personalInfo: {
        title: "Personal Information",
        fields: {
            name: {
                type: "text",
                label: "Username",
                readOnly: true,
                required: true,
            },
            account_type: {
                type: "text",
                label: "Account Type",
                readOnly: true,
                required: true,
            },
            ssn_id: {
                type: "password",
                label: "SSN / Tax ID",
                minLength: 9,
                required: true,
                toggleable: true,
                validation: "ssn",
            },
            client: {
                type: "text",
                label: "Full Name",
                required: true,
            },
            contact_primary: {
                type: "text",
                label: "Primary Contact",
                required: true,
                showIf: (formData) => formData.account_type === 'business'
            },
            client_dob: {
                type: "date",
                label: "Date of Birth",
                required: true,
                maxDate: new Date(),
                showIf: (formData) => formData.account_type === 'personal'
            },
            address: {
                type: "textarea",
                label: "Mailing Address",
                required: true,
                rows: 3
            }
        }
    },
    contactInfo: {
        title: "Contact Information",
        fields: {
            phone_primary: {
                type: "tel",
                label: "Client Phone",
                required: true,
                validation: "phone"
            },
            phone_secondary: {
                type: "tel",
                label: "Alternate Phone",
                validation: "phone",
                required: false,
            },
            email: {
                type: "email",
                label: "Client Email",
                required: true
            },

        }
    },
    businessInfo: {
        title: "Business Information",
        showIf: (formData) => formData.account_type === 'business',
        fields: {
            occupation: {
                type: "select",
                label: "Type of Business",
                required: true,
                options: [
                    { value: "", label: "Select" },
                    { value: "Individual/Sole proprietor or Single-member LLC", label: "Individual/Sole proprietor or Single-member LLC" },
                    { value: "Corporation", label: "Corporation" },
                    { value: "Partnership", label: "Partnership" },
                    { value: "Limited Partnership", label: "Limited Partnership" },
                    { value: "Limited Liability Corporation", label: "Limited Liability Corporation" },
                    { value: "Trustee/estate", label: "Trustee/estate" },
                    { value: "Nonprofit Organization", label: "Nonprofit Organization" },
                    { value: "Other", label: "Other" }
                ]
            }
        }
    },
    personalTaxInfo: {
        title: "Tax Information",
        showIf: (formData) => formData.account_type === 'personal',
        fields: {
            filing_status: {
                type: "select",
                label: "Filing Status",
                required: true,
                options: [
                    { value: "", label: "Select Filing Status" },
                    { value: "Single", label: "Single" },
                    { value: "Head of Household", label: "Head of Household" },
                    { value: "Married Filing Joint Return", label: "Married Filing Joint Return" },
                    { value: "Married Filing Seperately", label: "Married Filing Separately" },
                    { value: "Qualifying Widow", label: "Qualifying Widow" }
                ]
            },
            dependents: {
                type: "select",
                label: "Do you have dependents?",
                required: true,
                options: [
                    { value: "", label: "Please Select" },
                    { value: 1, label: "Yes" },
                    { value: 0, label: "No" }
                ]
            },
            dependentFields: {
                required: false,
                template: [
                    {
                        id: 'dep_name',
                        label: 'Name',
                        type: 'text',
                        required: true,
                        placeholder: 'Enter Dependent Name'
                    },
                    {
                        id: 'dep_rel',
                        label: 'Relationship',
                        type: 'text',
                        required: true,
                        placeholder: 'Enter Dependent Relationship'
                    },
                    {
                        id: 'dep_dob',
                        label: 'DOB',
                        type: 'date',
                        required: true
                    },
                    {
                        id: 'dep_ssn',
                        label: 'SSN',
                        type: 'password',
                        required: true,
                        showPasswordToggle: true,
                        formatter: 'ssn',
                        minLength: 9
                    }
                ]
            },

            state_return: {
                type: "select",
                label: "Will you be filing a state return?",
                required: true,
                options: [
                    { value: "", label: "Please Select" },
                    { value: "yes_state_return", label: "Yes" },
                    { value: "No", label: "No" }
                ]
            },
            st_return: {
                type: "select",
                label: "Select State",
                required: true,
                showIf: (formData) => formData.state_return === 'yes_state_return',
                options: states
            }
        }
    },

    spouseInfo: {
        title: "Spouse Information",
        showIf: (formData) => ['Married Filing Joint Return', 'Married Filing Seperately'].includes(formData.filing_status),
        fields: {
            spouse_name: {
                type: "text",
                label: "Spouse's Name",
                required: true,
                help: "As it appears on their SS Card"
            },
            spouse_dob: {
                type: "date",
                label: "Spouse DOB",
                required: true,
                maxDate: new Date()
            },
            spouse_ssn: {
                type: "password",
                label: "Spouse SSN",
                required: true,
                toggleable: true,
                validation: "ssn"
            },
            spouse_email: {
                type: "email",
                label: "Spouse Email",
                required: true
            },
            spouse_occupation: {
                type: "text",
                label: "Spouse Occupation",
                required: true
            }
        }
    },
    bankingInfo: {
        title: "Direct Deposit Information",
        subTitle: "Please provide the account information you would like to use for your refund or your balance due to the IRS (If Applicable)",
        fields: {
            rt_number: {
                type: "password",
                label: "Bank Routing #",
                required: true,
                minLength: 9,
                maxLength: 9,
                pattern: "^[0-9]{9}$",
                toggleable: true
            },
            act_number: {
                type: "password",
                label: "Account #",
                required: true,
                pattern: "^[0-9]+$",
                toggleable: true
            },
            bank_name: {
                type: "text",
                label: "Bank Name",
                required: true,
                minLength: 3,
                maxLength: 200
            }
        }
    },
    clientInfo: {
        title: "Client Information",
        fields: {
            new_client: {
                type: "select",
                label: "Are You A New Client This Year?",
                required: true,
                options: [
                    { value: "", label: "Please Select" },
                    { value: "1", label: "Yes" },
                    { value: "0", label: "No" }
                ]
            },
            hear_aboutus: {
                type: "select",
                label: "How did you hear about us?",
                required: true,
                showIf: (formData) => formData.new_client == 1,
                options: [
                    { value: "", label: "Please Select" },
                    { value: "Facebook", label: "Facebook" },
                    { value: "Walk On", label: "Walk-in" },
                    { value: "Flyer", label: "Flyer" },
                    { value: "referral_hear", label: "Referral" },
                    { value: "Internet Search", label: "Internet Search" },
                    { value: "Yelp", label: "Yelp" },
                    { value: "Thumbtack", label: "Thumbtack" }
                ]
            },
            referral: {
                type: "text",
                label: "Referral Name",
                required: true,
                showIf: (formData) => formData.hear_aboutus === 'referral_hear'
            }
        }
    },
    preferences: {
        title: "Preferences",
        fields: {
            document_copies: {
                type: "select",
                label: "Document Delivery Preference",
                required: true,
                options: [
                    { value: "", label: "Select" },
                    { value: "Office Pick Up", label: "Office Pick Up" },
                    { value: "Portal Upload", label: "Portal Upload" }
                ]
            },
            preferred_preparer: {
                type: "select",
                label: "Preferred Preparer",
                dynamicOptions: true, // This will use the preparers prop
            }
        }
    }
};

export const dependentFields = {
    name: {
        type: 'text',
        label: 'Dependent Name',
        required: true,
        help: 'As it appears on their SS Card'
    },
    rel: {
        type: 'text',
        label: 'Relationship',
        required: true
    },
    dob: {
        type: 'date',
        label: 'Date of Birth',
        required: true,
        maxDate: new Date()
    },
    ssn: {
        type: 'password',
        label: 'Social Security Number',
        required: true,
        toggleable: true
    }
};
